import React from 'react';
import { Divider, Typography, theme } from 'antd';
import type { ComponentConfig } from '../types';

const { Title } = Typography;

interface SectionHeaderConfig extends ComponentConfig {
  type: 'sectionHeader';
}

interface SectionHeaderProps {
  config: SectionHeaderConfig;
  value?: any;
  onChange?: (event: any) => void;
  pageId: string;
  error?: string[];
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  config,
}) => {
  const { token } = theme.useToken();
  
  // Extract section header specific options from additionalOptions
  const options = config.additionalOptions || {};
  const level = options.level || 'h3';
  const showDivider = options.showDivider !== false; // Default to true
  const marginTop = options.marginTop || '16px';
  const marginBottom = options.marginBottom || '8px';

  // Map header levels to Ant Design Title levels
  const getTitleLevel = (): 1 | 2 | 3 | 4 | 5 => {
    switch (level) {
      case 'h1': return 1;
      case 'h2': return 2;
      case 'h3': return 3;
      case 'h4': return 4;
      default: return 3;
    }
  };

  const containerStyle: React.CSSProperties = {
    marginTop,
    marginBottom,
  };

  return (
    <div style={containerStyle}>
      <Title 
        level={getTitleLevel()} 
        style={{ 
          margin: 0,
          marginBottom: showDivider ? '8px' : '0',
          fontSize: level === 'h4' ? '14px' : undefined,
          fontWeight: level === 'h4' ? 600 : undefined
        }}
      >
        {config.label}
      </Title>
      {config.description && (
        <div style={{ 
          color: token.colorTextSecondary, 
          fontSize: '13px', 
          marginBottom: showDivider ? '8px' : '4px',
          lineHeight: '1.4'
        }}>
          {config.description}
        </div>
      )}
      {showDivider && (
        <Divider style={{ margin: '0 0 16px 0' }} />
      )}
    </div>
  );
}; 